import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import FaqAccordion from "@/components/FaqAccordion";
import CtaSection from "@/components/CtaSection";
import { FAQS } from "@/data/site";

export default function Faqs() {
  return (
    <>
      <Seo
        title="FAQs | Property Services Greensboro NC | Authentically Yours"
        description="Answers to common questions about cleaning, junk removal, service areas, insurance, and free estimates from Authentically Yours in Greensboro, NC."
        path="/faqs"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "FAQs", path: "/faqs" },
        ]}
        faq={FAQS}
      />
      <PageHero
        eyebrow="FAQs"
        title="Questions, Answered"
        intro="A few of the things clients ask most. Still unsure about something? Call or text us and we'll be glad to help."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "FAQs", path: "/faqs" },
        ]}
      />

      <div className="container-x py-20 sm:py-28">
        <Reveal className="max-w-3xl">
          <FaqAccordion items={FAQS} />
        </Reveal>
      </div>

      <CtaSection />
    </>
  );
}
